import { render } from "./GuestDetailPage.vue?vue&type=template&id=6d628f25"
import script from "./GuestDetailPage.vue?vue&type=script&lang=js"
export * from "./GuestDetailPage.vue?vue&type=script&lang=js"

import "@/css/GuestsPage.css?vue&type=style&index=0&lang=css&external"
import "@/css/AppLayout.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__